module.exports = __webpack_public_path__ + "img/hr-light-mud-decal-05.f766b17d.png";